<template>
  <div class="group-management-container">
    <div class="menu-router-container">
      <third-router-nav />
      <div class="simple-menu-right">
        <el-button type="success" icon="el-icon-plus" @click="addUser">
          新增
        </el-button>
      </div>
    </div>
    <div v-loading="loading" class="menu-stores">
      <div class="stores-contain">
        <div class="simple-menu">
          <simple-search :search-data="searchData" :is-unwind="false" @child-event="getSearch" @child-close="getReset" />
        </div>
        <div class="user-table">
          <table-people
            :table-data="tableData"
            :table-headers="tableHeaders"
            :is-page="true"
            :border="false"
            :total="total"
            :page="current"
            :page-size="size"
            :page-sizes="[5, 10, 25, 50, 100]"
            :page-background="false"
            page-layout="total, sizes, prev, pager, next, jumper"
            page-position="right"
            @currentPage="currentPage"
            @sizeChange="sizeChange"
          >
            <template slot="avatar" slot-scope="scope">
              <div class="heard-icon">
                <img :src="scope.row.avatar ? scope.row.avatar : avatarImage" class="table-more-icon">
              </div>
            </template>
            <template slot="companyVoList" slot-scope="scope">
              <p v-for="(item, index) in scope.row.companyVoList" :key="index">
                {{ item.isCompanyAdmin === 1 ? item.companyName : '' }}
              </p>
            </template>
            <template slot="options" slot-scope="scope">
              <div class="operation">
                <!--                <div class="operation-btn" @click="goDetail(scope.row.userId)">-->
                <!--                  详情-->
                <!--                </div>-->
                <div class="operation-btn edit-btn" @click="goEdit(scope.row)">
                  编辑
                </div>
                <!--                <div class="operation-btn disable-btn" @click="goDisable(scope.row.userId)">-->
                <!--                  停用-->
                <!--                </div>-->
                <div class="operation-btn-delete" @click="goDel(scope.row.userId)">
                  删除
                </div>
              </div>
            </template>
          </table-people>
        </div>
      </div>
    </div>
    <popup title="提示" :show.sync="show" :content="popupContent" confirm-button-text="确 定" background="#FF645F" @toTrue="toTrue" />
    <white-form ref="miniprogramForm" @fresh="getReset" />
  </div>
</template>

<script>
import SimpleSearch from '@/components/search/SimpleSearch'
import TablePeople from '@/components/table/TablePeople'
import Popup from '@/components/popup/Popup'
import ThirdRouterNav from '@/components/dashboard/ThirdRouterNav'
import WhiteForm from './white-form'
import avatarImage from '@/assets/images/avatar.png'
import { userGetPage, sysCompanyPage, deleteWhitelistUser } from '@/api/index'
export default {
  components: {
    SimpleSearch,
    TablePeople,
    Popup,
    ThirdRouterNav,
    WhiteForm
  },
  data() {
    return {
      avatarImage,
      loading: false,
      searchData: [
        { name: '姓名', field: 'nickName', type: 'text' },
        { name: '手机号码', field: 'phone', type: 'number' },
        { name: '所属公司', field: 'companyIdList', type: 'select',
          props: { multiple: true, collapseTags: true, filterable: true },
          options: []
        }
      ],
      size: 10,
      current: 1,
      total: 0,
      tableHeaders: [
        { prop: 'avatar', label: '头像' },
        { prop: 'nickName', label: '姓名', options: [{ type: 'sort' }] },
        { prop: 'phone', label: '手机号码', options: [{ type: 'sort' }] },
        { prop: 'email', label: '邮箱', options: [{ type: 'sort' }] },
        { prop: 'companyVoList', label: '管理公司名称', options: [{ type: 'sort' }] },
        { prop: 'options', label: '操作', width: 200 }
      ],
      tableData: [],
      show: false,
      popupContent: '',
      searchParams: {},
      userId: ''
    }
  },
  mounted() {
    this.getSysCompanyPage()
    this.getUserGetPage()
  },
  methods: {
    getSysCompanyPage() {
      const data = {
        current: 1,
        size: 9999
      }
      sysCompanyPage(data).then((res) => {
        if (res.data) {
          this.searchData[2].options = res.data.records.map(item => {
            return { label: item.companyName, value: item.id }
          })
        }
      })
    },
    getUserGetPage() {
      this.loading = true
      const data = {
        current: this.current,
        size: this.size,
        type: 2,
        ...this.searchParams
      }
      userGetPage(data).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.total = res.data.total
          this.tableData = res.data.records
        }
        // 在删除时候判断
        if (this.total > 0 && this.current > 1 && this.tableData.length === 0) {
          this.current -= 1
          this.getUserGetPage()
        }
      }).finally(result => {
        this.loading = false
      })
    },
    /**
     * 删除接口
     * */
    getDeleteUser() {
      deleteWhitelistUser(this.userId, 1).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getUserGetPage()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    // 查询
    getSearch(data) {
      this.current = 1
      this.size = 10
      const param = {}
      Object.keys(data).map(key => {
        data[key] && (param[key] = data[key])
      })
      this.searchParams = param
      this.getUserGetPage()
    },
    // 重置
    getReset() {
      this.current = 1
      this.size = 10
      this.searchParams = {}
      this.getUserGetPage()
    },
    // 分页页数改变
    currentPage(page) {
      this.current = page
      this.getUserGetPage()
    },
    /**
     * 分页大小改变
     * */
    sizeChange(size) {
      this.size = size
      this.getUserGetPage()
    },
    // 详情
    goDetail(id) {
      console.log(id)
    },
    // 新增
    addUser() {
      this.$refs.miniprogramForm.init()
    },
    // 编辑
    goEdit(row = {}) {
      this.$refs.miniprogramForm.init(row)
      console.log(row)
    },
    // 停用
    goDisable(id) {
      this.popupContent = id === 0 ? '用户将停止访问丹纳赫医学诊断平台移动端<br /><br />请确认是否停用？' : '用户将启用访问丹纳赫医学诊断平台移动端<br /><br />请确认是否启用？'
      this.show = true
      console.log(id)
    },
    // 删除
    goDel(id) {
      this.popupContent = '是否删除？'
      this.show = true
      this.userId = id
    },
    // 点击确定弹窗
    toTrue() {
      this.show = false
      this.getDeleteUser()
    }
  }
}
</script>

<style lang="scss" scoped>
  .group-management-container {
    background-color: #fff;
    width: 100%;
    flex: 1;
    .menu-router-container {
      display: flex;
      justify-content: space-between;
      background-color: #ebeeef;
      .simple-menu-right {
        width: 200px;
        margin-right: 40px;
        display: flex;
        justify-content: flex-end;
        .el-button {
          height: 32px;
          line-height: 32px;
          padding: 0 10px;
          margin-left: 15px;
        }
      }
    }
    .menu-stores {
      padding: 20px;
    }
    .user-table {
      width: 100%;
      margin-top: 30px;
      .heard-icon{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        >img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .disable-btn {
        color: #999999;
      }
      .edit-btn {
        color: #E6A23C;
      }
      .del-btn {
        color: #FF3939;
      }
    }
  }
</style>
